var map = {
	"./img/appbar_cathedral.png": 7441,
	"./img/appbar_crimson.png": 3542,
	"./img/appbar_skolhive.png": 3724,
	"./img/favicon.ico": 2177,
	"./img/inventory.png": 6838,
	"./img/logosmall_cathedral.png": 4689,
	"./img/logosmall_crimson.png": 4582,
	"./img/logosmall_skolhive - Copy.png": 6118,
	"./img/onlylogo_cathedral.png": 46,
	"./img/onlylogo_crimson.png": 121,
	"./img/onlylogo_skolhive.png": 1689,
	"./img/parents.png": 765,
	"./img/principal.jpg": 1996,
	"./img/sidebar_cathedral.png": 9875,
	"./img/sidebar_crimson.png": 9556,
	"./img/sidebar_skolhive.png": 2962,
	"./img/students.png": 5248,
	"./img/support.png": 5315,
	"./img/teacher.jpg": 7000,
	"./img/teacher.png": 5692,
	"./img/worker.png": 1342,
	"./img/xl.png": 0
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;